import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { createStore } from './store/store';
import { initRoot } from './store/actions/init';
import AppProvider from './AppProvider';
import MainFetch from './main/MainFetch';
import FeaturesFetch from './steps/config/trims/trimFeaturesCompare/FeaturesFetch';
import Notifications from './components/notifications/Notifications';
import { trimEnd } from 'lodash';
import { getBase } from './utils/uri';
import BodyComparePage from './components/bodyComparePage/BodyComparePage';

const App = () => {
  window.__cache__ = new Map();
  window.__store__ = createStore();
  window.__store__.dispatch(initRoot());

  const basename = trimEnd(
    getBase(document).replace(window.location.origin, ''),
    '/'
  );

  return (
    <AppProvider>
      <Routes basename={basename}>
        <Route path={`features/trims/*`} element={<FeaturesFetch />} />
        <Route
          path={`features/capabilities/*`}
          element={<FeaturesFetch isCapabilities={true} />}
        />
        <Route path={`bodycompare/:id`} element={<BodyComparePage />} />
        <Route path="/*" element={<MainFetch basename={basename} />} />
      </Routes>
      <Notifications />
    </AppProvider>
  );
};

export default App;
